import {SceneNodes, TemplateNode} from "@cm/template-nodes"

export type SceneNodeInfoTreeItem = SceneNodeInfoNode | SceneNodes.SceneNode

export type SceneNodeInfoNode = {
    id: string
    templateNode: TemplateNode
    children: SceneNodeInfoTreeItem[]
}

export const getNodeChildren = (node: SceneNodeInfoTreeItem): SceneNodeInfoTreeItem[] => {
    if (SceneNodes.isSceneNode(node)) {
        return []
    }

    const sceneNodeChildren = node.children.filter((child): child is SceneNodes.SceneNode => SceneNodes.isSceneNode(child))
    if (sceneNodeChildren.length === node.children.length) {
        const referencedDataObjects = sceneNodeChildren.filter(SceneNodes.DataObjectReference.is)
        if (referencedDataObjects.length >= sceneNodeChildren.length - 1) return referencedDataObjects
    }

    return node.children
}

export const hasChildren = (node: SceneNodeInfoTreeItem) => getNodeChildren(node).length > 0
